import { useNavigate } from "react-router-dom";
import { ShoppingBag, X } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { formatAsMoney } from "../helpers/numbers";
import { useGetCart } from "../hooks/useGetCart";
import { HashLoader } from "react-spinners";
import CartItem from "./CartItem";

const Cart = () => {
  const { cartData, fetchingCart } = useGetCart();

  const navigate = useNavigate();

  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
      }}
      onClick={() => {
        navigate(-1);
      }}
      className="fixed bg-gray-900/5 top-0 left-0 w-screen h-screen flex justify-end z-[999999999]"
    >
      <motion.div
        onClick={(e) => e.stopPropagation()}
        initial={{
          x: "100%",
        }}
        animate={{
          x: 0,
        }}
        exit={{
          x: "100%",
        }}
        transition={{
          duration: 0.5,
        }}
        className="bg-white p-5 border h-full max-w-lg w-full flex flex-col gap-4"
      >
        <div className="flex-1 flex flex-col gap-4 w-full">
          <div className="flex items-center justify-between gap-2">
            <div className="font-medium text-lg">Your Cart</div>
            <button
              onClick={() => {
                navigate(-1);
              }}
              type="button"
              className="bg-gray-50 border rounded-full p-1"
            >
              <X size={18} />
            </button>
          </div>
          {fetchingCart ? (
            <div className="flex-1 flex items-center justify-center">
              <HashLoader />
            </div>
          ) : (
            <div className="flex-1 overflow-y-auto w-full">
              {cartData?.data?.items?.length ? (
                <div className="flex flex-col w-full gap-4">
                  {cartData?.data?.items?.map((item) => {
                    return <CartItem key={item.id} item={item} />;
                  })}
                </div>
              ) : (
                <div className="flex flex-col gap-2 justify-center items-center py-10 h-full">
                  <div className="bg-visaro-orange/5 rounded-full p-4 text-visaro-orange">
                    <ShoppingBag size={28} />
                  </div>
                  <div className="flex flex-col gap-2 items-center">
                    <div>You don't have any items in your cart.</div>
                    <Link
                      to="/marketplace"
                      className="p-2 text-sm bg-visaro-orange rounded-lg text-white px-5"
                    >
                      Start Shopping
                    </Link>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="flex flex-col gap-4 border-t pt-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between font-medium text-xl">
              <div>Total</div>
              <div>₦{formatAsMoney(cartData?.data?.total_amount || 0)}</div>
            </div>
          </div>
          <Link
            to={`/marketplace/checkout/${cartData?.data?.id}`}
            className="p-4 px-5 w-full text-center border-visaro-gray-700 border rounded-lg font-bold bg-deepBlue text-white text-sm"
          >
            Checkout
          </Link>
          <div className="text-center text-sm">
            By clicking “Checkout”. you agree to our{" "}
            <Link to="/legal" className="text-visaro-orange">
              Return policy
            </Link>{" "}
            &{" "}
            <Link to="/legal" className="text-visaro-orange">
              Terms and Conditions
            </Link>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Cart;
